import styled from 'styled-components';

export const Container = styled.div`
	padding: 16px;

	& > .ant-card {
		margin-bottom: 16px;
		width: 100%;
		height: 100%;
	}

	.ant-collapse-borderless > .ant-collapse-item {
		border: none !important;
		background: transparent !important;
	}

	.ant-card-body {
		padding: 0 !important;
		width: 100%;
		height: 600px;
		display: flex;
		flex-direction: column;

		& div.__body-content {
			display: flex;
			justify-content: center;
			padding: 15px 0;
			overflow: auto;
			flex: 1;
		}

		& footer.__actions {
			width: 100%;
			display: flex;
			padding: 15px 25px;
			justify-content: flex-end;
			border-top: 1px solid #dedede;
		}
	}
`;

export const ContentContainer = styled.div`
	min-width: 600px;
	max-width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;

	& > button {
		width: 100%;
	}
`;

export const NamesContainer = styled.ul`
	width: 100%;
	margin: 0;
	padding: 0;
	margin-bottom: 10px;
`;

export const NamesConfigRow = styled.li`
	list-style: none;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 4px;
	border: 1px solid #f1f1f1;
	padding: 10px;
	border-radius: var(--border-radius-base);

	&:hover {
		border-color: var(--primary);
	}

	& > div.label {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		& > span {
			font-size: 18px;
			font-weight: 600;
		}
	}

	& > div.divider {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 25px;
	}

	& div.actions {
		display: flex;
		gap: 8px;

		& > input {
			width: 300px;
		}

		& > button {
			margin-left: 5px;
		}
	}
`;
